import { Badge, Button, Separator } from '@monksflow/monks-ui';

import { RatingsDisplay } from '../RatingsDisplay';

import type { TerritoryCardProps } from './TerritoryCard.types';
import { useTranslation } from 'react-i18next';

export const TerritoryCard = ({ onClick, territory }: TerritoryCardProps) => {
  const { t } = useTranslation('analysis');

  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-border p-6">
      {territory.isRecommended && (
        <Badge variant="secondary" className="w-fit">
          {t('strategicTerritoriesWidget.territoryCard.recommended')}
        </Badge>
      )}

      <p className="wrap-break-word text-heading-md font-medium text-foreground">
        {territory.title}
      </p>

      <p data-testid="territory-summary" className="text-body-md text-muted-foreground">
        {territory.summary}
      </p>

      <Separator />

      <RatingsDisplay ratings={territory.ratings} />

      <Button className="mt-2 w-fit" variant="outline" onClick={onClick}>
        {t('strategicTerritoriesWidget.territoryCard.exploreTerritory')}
      </Button>
    </div>
  );
};
